import { getFromLocalStorage } from "../../../utils/webStorage";
import Paper from "@material-ui/core/Paper";
import { useEffect, useState } from "react";
import Buttons from "./buttons";
import { button_data } from "./ContainerButtons";
import VideoEdits from "./FilterActivity/VideoEdits";
import SharedVideos from "./FilterActivity/VideoShared";
import MembersAddedContainer from "./FilterActivity/MembersAddedContainer";
import AllACtivityPage from "./FilterActivity/AllActivity";
import SeasonAddedContainer from "./FilterActivity/SeasonAddedContainer";
import ScheduleAddedContainer from "./FilterActivity/ScheduleAddedContainer";
import { useDispatch, useSelector } from "react-redux";
import {
  getAddedSeasonActivity,
  getAllActivityHistory,
  getAddedScheduleActivity,
  getVideoEditActivityHistory,
  getSharedVideoActivity,
  getAddedMemberActivity,
  resetActivityHistoryInitialState,
} from "../../../Redux/Actions/ActivityHistoryAction";

const ActivityHistory = () => {
  const schoolName = getFromLocalStorage("schoolName");
  const [activeBtn, setActiveBtn] = useState(button_data[0].value);
  const activityHistoryData = useSelector((state) => state.activityHistoryData);
  const dispatch = useDispatch();

  useEffect(() => {
    getAllActivityHistory(dispatch, {
      pageNumber: activityHistoryData?.pageNumber,
      status: true,
    });
    return () => {
      resetActivityHistoryInitialState(dispatch, {});
    };
  }, []);

  const handleClick = (name) => {
    switch (name) {
      case "Video Edits":
        getVideoEditActivityHistory(dispatch, {
          pageNumber: activityHistoryData?.pageNumber,
          status: true,
        });
        break;

      case "Video Shared":
        getSharedVideoActivity(dispatch, {
          pageNumber: activityHistoryData?.pageNumber,
          status: true,
        });
        break;

      case "Members Added":
        getAddedMemberActivity(dispatch, {
          pageNumber: activityHistoryData?.pageNumber,
          status: true,
        });
        break;

      case "Season Added":
        getAddedSeasonActivity(dispatch, {
          pageNumber: activityHistoryData?.pageNumber,
          status: true,
        });
        break;

      case "Schedule Added":
        getAddedScheduleActivity(dispatch, {
          pageNumber: activityHistoryData?.pageNumber,
          status: true,
        });
        break;

      case "All Activity":
        getAllActivityHistory(dispatch, {
          pageNumber: activityHistoryData?.pageNumber,
          status: true,
        });
        break;

      default:
        break;
    }
    setActiveBtn(name);
  };

  return (
    <div className="activity-main-container">
      <Paper className="activity-trending-container pd-15 mg-bottom-20">
        <h2 className="fs-28 bold black mobofs36">Activity History</h2>
        <div className="activity-trending-btn-container">
          <Buttons
            buttonData={button_data}
            activebtn={activeBtn}
            handleClick={handleClick}
          />
        </div>
      </Paper>

      <div className="height-350 overflow-y">
        <div className="mng-home-cont-width">
          {activeBtn == "Video Edits" ? (
            <VideoEdits schoolName={schoolName} />
          ) : null}
        </div>

        <div className="mng-home-cont-width">
          {activeBtn == "Video Shared" ? <SharedVideos /> : null}
        </div>

        <div className="mng-home-cont-width">
          {activeBtn == "Members Added" ? <MembersAddedContainer /> : null}
        </div>

        <div className="mng-home-cont-width">
          {activeBtn == "All Activity" ? <AllACtivityPage /> : null}
        </div>

        <div className="mng-home-cont-width">
          {activeBtn == "Season Added" ? <SeasonAddedContainer /> : null}
        </div>

        <div className="mng-home-cont-width">
          {activeBtn == "Schedule Added" ? <ScheduleAddedContainer /> : null}
        </div>
      </div>
    </div>
  );
};

export default ActivityHistory;
